import React, { useMemo } from "react";
import { Card, Typography, Tooltip } from "@mui/material";
import "./ClientActivityChart.css";
import { CLIENT_ACTIVITY_CHART_HEIGHT, CLIENT_ACTIVITY_METRICS } from "../../Utility/constant";


export default function ClientActivityChart({ data }) {
  const record = Array.isArray(data) ? data[0] : data;

  const bars = useMemo(() => {
    // No record? Still show all metrics, just zeroed out.
    return CLIENT_ACTIVITY_METRICS.map((m) => ({
      ...m,
      value: record?.[m.key] ?? 0,
    }));
  }, [record]);

  const maxValue = useMemo(() => {
    const max = Math.max(...bars.map((b) => b.value), 0);
    return max === 0 ? 1 : max; // avoid divide-by-zero
  }, [bars]);

  return (
    <Card className="activityChart-card">
      <div className="activityChart-barsContainer">
        {bars.map((bar) => {
          const barHeight = (bar.value / maxValue) * CLIENT_ACTIVITY_CHART_HEIGHT;

          return (
            <div className="activityChart-barColumn" key={bar.key}>
              <Typography
                variant="subtitle2"
                className="activityChart-valueLabel"
                style={{ color: bar.color }}
              >
                {bar.value}
              </Typography>

              <Tooltip title={`${bar.label}: ${bar.value}`} arrow placement="top">
                <div
                  className="activityChart-bar"
                  style={{
                    height: `${barHeight}px`,
                    backgroundColor: bar.color,
                  }}
                />
              </Tooltip>

              <Typography variant="caption" className="activityChart-categoryLabel">
                {bar.label}
              </Typography>
            </div>
          );
        })}
      </div>

      <Typography variant="caption" className="activityChart-dateRange">
        {record?.fromDate} → {record?.toDate}
      </Typography>
    </Card>
  );
}